import React, { useEffect, useState } from "react";
import { Body1Strong, Text, Image } from "@fluentui/react-components";
import { WidgetProps } from '@rjsf/utils';
import { MultiselectWithTags } from "../dropdown/multiselect.component";
import { Stack, StackItem } from "@fluentui/react";
import { Button } from "@fluentui/react-components";
import { Dismiss12Regular } from "@fluentui/react-icons";

export const MultipleSelectToStringTanent = (props: WidgetProps) => {
  // Parse initial value once
  const [selectedOptions, setSelectedOptions] = useState(() => {
    return props.value ? props.value.split(', ').filter(Boolean) : [];
  });
  
  // Only update the form when selectedOptions changes, with debounce
  useEffect(() => {
    const newValue = selectedOptions.join(', ');
    if (newValue !== props.value) {
      props.onChange(newValue);
    }
  }, [selectedOptions]);

  // Only sync with props.value if it's different from our current state
  useEffect(() => {
    const propsOptions = props.value ? props.value.split(', ').filter(Boolean) : [];
    const currentValue = selectedOptions.join(', ');
    if (props.value !== currentValue) {
      setSelectedOptions(propsOptions);
    }
  }, [props.value]);

  const onTagRemoveClick = (option: string, index: number) => {
    setSelectedOptions(prev => prev.filter(val => val !== option));
  };

  // Create a sorted copy of the options - memoize to prevent unnecessary recalculation
  const sortedOptions = React.useMemo(() => {
    return [...props.schema.enumNames].sort((a, b) => 
      a.toLowerCase().localeCompare(b.toLowerCase())
    );
  }, [props.schema.enumNames]);

  return (
    <Stack tokens={{ childrenGap: 2 }}>
      <Text>
        <Body1Strong>
          {props.label}
          <Image src="/Dashboard/image/required.svg" />
        </Body1Strong>
      </Text>
      <StackItem><Text></Text></StackItem>
      <StackItem>
        {selectedOptions.length > 0 && (
          <div>
            {selectedOptions.map((option, i) => (
              <span key={`${option}-${i}`}>
                <Button
                  size="small"
                  shape="circular"
                  appearance="primary"
                  id={`${option}-remove-${i}`}
                  aria-labelledby={`${option}-remove ${option}-remove-${i}`}
                  disabled={props.disabled}
                >
                  {option}
                  <Dismiss12Regular 
                    onClick={() => onTagRemoveClick(option, i)} 
                    id={`${option}-remove-${i}`} 
                    aria-labelledby={`${option}-remove ${option}-remove-${i}`} 
                  />
                </Button>
              </span>
            ))}
          </div>
        )}
      </StackItem>
      <StackItem><Text></Text></StackItem>
      <MultiselectWithTags
        options={sortedOptions}
        multi={true}
        tag={false}
        disabled={props.disabled}
        selectedOptions={selectedOptions}
        setSelectedOptions={setSelectedOptions}
        required={selectedOptions.length === 0}
      />
    </Stack>
  );
};